<div #loadingGif *ngIf="environment.enableDesktopMode" class="loading-gif-container">
  <img class="loading-gif" src="assets/start.gif" alt="" />
</div>
<div *ngIf="isLoaded" [ngClass]="{'blur': isMiniPlayerOpen}" class="app-container {{currentApplicationVersion}}">
  <main [ngClass]="{'isLogged': hasLoggedInRemote$ | async}">
    <div [ngStyle]="{'background-image': 'url(' + backgroundImage + ')'}" class="background-app"></div>
    <img *ngIf="isLoggedIn" [src]="coverUrl" alt="" id="coverBg" />
    <div class="blur"></div>
    <mwo-side-panel *ngIf="hasLoggedInRemote$ | async"></mwo-side-panel>
    <router-outlet (activate)="onActivate($event)"></router-outlet>
  </main>

  <!--  <mwo-side-panel *ngIf="hasLoggedInRemote$ | async"></mwo-side-panel>-->

  <footer *ngIf="hasLoggedInRemote$ | async" class="footer">
    <mwo-player (onDisplayMiniPlayer)="openMiniPlayer()"></mwo-player>
  </footer>
</div>